<div *transloco="let t" class="flex flex-row items-center gap-2">
	@if (!!dialogParameters()) {
		<ara-popover [content]="canOpenDialog() ? this.getPermissionCodesStatusPopover() : ''">
			<button araButton="icon" type="button" [attr.aria-label]="t('permissions.codes')" (click)="canOpenDialog() && openPermissionsDialog()">
				<mat-icon
					class="permission-badge-icon"
					fontSet="material-symbols-outlined"
					[matBadge]="getPermissionBadgeLabel()"
					[matBadgeDescription]="getPermissionBadgeLabel() + 'permissions'"
					matBadgePosition="above after"
					matBadgeSize="large">
					qr_code_2
				</mat-icon>
			</button>
		</ara-popover>
		@if (canCreatePermission()) {
			<ara-popover [content]="t('permissions.createPermission')">
				<button
					araButton="icon"
					type="button"
					[attr.aria-label]="t('permissions.createPermission')"
					(click)="openCreatePermissionDialog()"
					color="primary">
					<mat-icon fontSet="material-symbols-outlined">add</mat-icon>
				</button>
			</ara-popover>
		}
	}
</div>
